// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[data-v-540388de]::-webkit-inner-spin-button,input[data-v-540388de]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number][data-v-540388de]{-moz-appearance:textfield}.pendente[data-v-540388de]{color:#1f2d3d;background-color:#ffc107;font-weight:700}", ""]);
// Exports
module.exports = exports;
